//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      domain:{
        name:'',
        org:''
      },
      dns1:'',
      dns2:'',
    }
  },
  mounted() {
    this.DomainQuery()
  },
  methods:{
    DomainQuery() {
      let data = 'cmd=domain_query'+
        '&id='+ this.$route.params.id
      this.$http.post('https://api.abeiyun.com/www/domain.php', data).then(({data}) => {
        if(data.response == 200) {
          this.dns1 = data.info.msg.data.dns[0]
          this.dns2 = data.info.msg.data.dns[1]
          this.domain.name = data.info.msg.data.domain
          this.domain.org = data.info.msg.org
        }
      })
    },
    async submit() {
      let data = 'cmd=updns'+
        '&domainname='+ this.domain.name +
        '&org='+ this.domain.org +
        '&server1='+ this.dns1 +
        '&server2='+ this.dns2
      this.$http.post('https://api.abeiyun.com/www/domain.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/changedns.vue